import React from 'react';
import { dispositionColor as matrixColor, matrixName } from '../dispositionPalette';
import { WS_CHIP, WS_FONT, WS_STATUS } from '../workspace/ws';

/**
 * The application's disposition beside its ID (owner requests 2026-11-03 and 2026-11-04):
 * Roadmap Visualization (Gantt and table), Roadmap Schedule (Gantt and table) and
 * Application Interdependencies. One component so the three screens cannot drift apart.
 *
 * A FILLED chip in the Disposition Matrix colour (§1.9.3 rules 2-3); the kit's neutral pair
 * for a value the matrix does not know. The ID beside it stays black — the chip carries the
 * colour, so the ID is not coloured too (§1.9.3 rule 5).
 */
export const dispositionChipStyle = (disposition: string | null | undefined): React.CSSProperties => {
  const known = matrixColor(disposition);
  const inMatrix = !!disposition && known.base !== matrixColor(null).base;
  return {
    ...WS_CHIP,
    marginLeft: 8,
    flexShrink: 0,
    fontFamily: WS_FONT.sans,
    backgroundColor: inMatrix ? known.base : WS_STATUS.neutral.fill,
    color: inMatrix ? known.onBase : WS_STATUS.neutral.ink,
  };
};

export const DispositionChip: React.FC<{ value?: string | null }> = ({ value }) =>
  value ? (
    <span data-testid="disposition-chip" style={dispositionChipStyle(value)}>
      {matrixName(value) || value}
    </span>
  ) : null;

export default DispositionChip;
